// extracted by mini-css-extract-plugin
export var contentBody = "_c8-9";
export var headerImage = "_c8-2";
export var imageButton = "_c8-7";
export var imageButtonIcon = "_c8-8";
export var imageHeader = "_c8-4";
export var imageHeaderText = "_c8-5";
export var imageOverlay = "_c8-3";
export var imageTitle = "_c8-6";
export var imageWrapper = "_c8-1";
export var taskList = "_c8-a";
export var widget = "_c8-0";